export default __webpack_public_path__ + "static/media/hdb-flat-3.64cb5bc9.svg";